import React, { useCallback } from 'react';
import NiceModal, { antdModalV5, useModal } from '@ebay/nice-modal-react';
import { Modal, Table } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { TableMainText, TableSecondaryText } from 'styles';

import { useBadgeList } from 'api/badges';
import { SMALL_PAGE_SIZE } from 'appConstants';
import StatusTag from 'components/StatusTag';
import TableTimestamp from 'components/TableTimestamp';
import { useListState } from 'hooks';

const columns: ColumnProps<any>[] = [
  {
    title: 'Name',
    key: 'name',
    render: (_, record: any) => (
      <>
        <TableMainText>{record.internal_name}</TableMainText>
        <TableSecondaryText>ID: {record.id}</TableSecondaryText>
      </>
    )
  },
  {
    title: 'Start date',
    dataIndex: 'start_date',
    key: 'start_date',
    width: 150,
    render: value => <TableTimestamp timestamp={value} />
  },
  {
    title: 'End date',
    dataIndex: 'end_date',
    key: 'end_date',
    width: 150,
    sorter: true,
    render: value => <TableTimestamp timestamp={value} />
  },
  {
    title: 'Status',
    dataIndex: 'state',
    key: 'state',
    render: state => <StatusTag state={state} />
  }
];

const BadgeSelectModal = NiceModal.create(() => {
  const modal = useModal();

  const { handleTableChange, pagination, params } = useListState({
    state: 'active',
    size: SMALL_PAGE_SIZE
  });

  const { data, meta, isLoading } = useBadgeList(params);

  const handleOk = () => {
    modal.resolve();
    modal.hide();
  };

  const chooseMultiple = false;
  const shouldSubmitOnRowClick = !chooseMultiple;

  const rowProps = useCallback(
    (record, _) => ({
      onClick: () => {
        if (shouldSubmitOnRowClick) {
          modal.resolve(record);
          modal.hide();
        }
      },
      style: { cursor: shouldSubmitOnRowClick ? 'pointer' : 'auto' }
    }),
    [shouldSubmitOnRowClick, modal]
  );

  return (
    <Modal
      {...antdModalV5(modal)}
      onOk={handleOk}
      title="Select a badge"
      width={1200}
      okButtonProps={shouldSubmitOnRowClick ? { style: { display: 'none' } } : null}
    >
      <Table
        rowKey="id"
        dataSource={data}
        columns={columns}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={{ ...pagination, total: meta?.count || 0 }}
        onRow={rowProps}
      />
    </Modal>
  );
});

export default BadgeSelectModal;
